import React, { ReactNode, useMemo, useState } from "react";
import { useAtom } from "jotai";
import moment from "moment";
import { transformItemsGroup } from "features/ProductsGroup/helpers";

import { Calendar, Value } from "components/Calendar/Calendar";
import { NamedSelect } from "components/NamedSelect/NamedSelect";
import { RegularText } from "components/RegularText/RegularText";
import { TimePicker } from "components/TimePicker";
import { Option } from "components/Select/Select";
import { Accordion } from "components/Accordion/Accordion";
import { Checkbox } from "components/Checkbox/Checkbox";

import DaysServices from "utils/days";

import { reportsFiltersAtom } from "../../atoms/reportsAtom";
import { storesAtom } from "../../atoms/storeAtom";
import { ItemsGroupWithChildren } from "../../types";
import { itemsGroupAtom } from "../../atoms/itemsGropAtom";

import styles from "./styles.module.scss";

const ElementsContainer = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div className="flex items-center mt-2 gap-1">{children}</div>
);

export const Header = ({ isMultiStore }): JSX.Element => {
  const [reportsFilters, setReportsFilters] = useAtom(reportsFiltersAtom);

  const [visibleCalendarStart, setVisibleCalendarStart] =
    useState<boolean>(false);
  const [visibleCalendarEnd, setVisibleCalendarEnd] = useState<boolean>(false);

  const [stores] = useAtom(storesAtom);
  const storesOptions: Option[] = useMemo(
    () => stores.map((i) => ({ value: i.storesid, label: i.name })),
    [stores]
  );

  const onDateChange = (field: "dateFrom" | "dateTo") => (val) => {
    setReportsFilters({
      [field]: DaysServices.setDateTime(
        val,
        moment(reportsFilters?.[field]).format("HH:mm:ss")
      ),
    } as any);
  };

  const onTimeChange = (field: "dateFrom" | "dateTo") => (val) => {
    setReportsFilters({
      [field]: DaysServices.setDateTime(reportsFilters?.[field], val),
    } as any);
  };

  const handleStores = (val) => {
    if (!val?.value) {
      return setReportsFilters({ storeIds: [] } as any);
    }

    setReportsFilters({
      storeIds: isMultiStore ? val.map((i) => i.value) : [val.value],
    } as any);
  };

  return (
    <div className={styles.filtersHeader}>
      <ElementsContainer>
        <RegularText size={14} className={styles.filterText}>
          Начальная дата:
        </RegularText>
        <Calendar
          onShow={() => setVisibleCalendarStart(!visibleCalendarStart)}
          setVisibleCalendar={setVisibleCalendarStart}
          visibleCalendar={visibleCalendarStart}
          onChange={onDateChange("dateFrom")}
          value={reportsFilters?.dateFrom || null}
        />
        <TimePicker
          value={moment(reportsFilters?.dateFrom).format("HH:mm:ss") || ""}
          onChange={onTimeChange("dateFrom")}
        />
      </ElementsContainer>
      <ElementsContainer>
        <RegularText size={14} className={styles.filterText}>
          Конечная дата:
        </RegularText>
        <Calendar
          onShow={() => setVisibleCalendarEnd(!visibleCalendarEnd)}
          setVisibleCalendar={setVisibleCalendarEnd}
          visibleCalendar={visibleCalendarEnd}
          onChange={onDateChange("dateTo")}
          value={reportsFilters?.dateTo || null}
        />
        <TimePicker
          value={moment(reportsFilters?.dateTo).format("HH:mm:ss") || ""}
          onChange={onTimeChange("dateTo")}
        />
      </ElementsContainer>
      <ElementsContainer>
        <RegularText size={14} className={styles.filterText}>
          Склад:
        </RegularText>
        <NamedSelect
          options={storesOptions}
          placeholder={"Выберите склад"}
          className={styles.filterSelect}
          isMulti={isMultiStore}
          onChange={handleStores}
          isClearable
        />
      </ElementsContainer>
      {/*      <ElementsContainer>
        <RegularText size={14}>Группа клиентов:</RegularText>
        <NamedSelect options={[]} />
      </ElementsContainer>
      <ElementsContainer>
        <RegularText size={14}>Показать удалённые группы</RegularText>
        <NamedCheckbox checked={false} />
      </ElementsContainer>
      <ElementsContainer>
        <RegularText size={14}>Только предзаказы</RegularText>
        <NamedCheckbox checked />
      </ElementsContainer>
      <ElementsContainer>
        <RegularText size={14}>Учитывая инвентаризации</RegularText>
        <NamedCheckbox checked={false} />
      </ElementsContainer>*/}
    </div>
  );
};
